import { LogIn } from 'lucide-react';
import { ShiftinLogo } from '../components/ShiftinLogo.js';
import { ThemeToggle } from '../components/ThemeToggle.js';

// Single-button sign-in. The button is a native <a> hitting
// /api/auth/google so the browser follows the server's 302 to
// Google. After the OAuth dance the server's callback sets the
// session cookie and 302s back to APP_URL (= this app's root).
//
// The backend renders its own styled rejection page on allowlist
// failures (server/src/routes/auth.ts) — we don't need to handle
// that case here.

export function LoginPage() {
  return (
    <div className="login-shell">
      <ThemeToggle />
      <div className="login-card">
        <div className="login-logo">
          <ShiftinLogo compact height={56} />
        </div>
        <h1>Pointage</h1>
        <p>
          Accès réservé aux comptes du groupe SHIFTIN. Employés : connectez-vous
          avec votre adresse email professionnelle pour accéder à votre espace.
        </p>
        <a className="login-button" href="/api/auth/google" data-testid="signin-google">
          <LogIn aria-hidden="true" />
          Sign in with Google Workspace
        </a>
      </div>
    </div>
  );
}
